import React from "react";
import CasestudyTemplate from "../../../../templates/casestudyTemplate";

export default function IndexPage() {
  return (
    <CasestudyTemplate id="hospedia">
      The Hospedia mobile app allows patients, friends and family to manage
      their bedside entertainment account from their mobile device. ## My role
      Throughout this project I was the main point of contact for everything
      relating to design. During early brainstorming sessions I liaised with key
      stakeholders to determine what features were going to be available in the
      phase one release as well as further road map items. I was responsible for
      conceptualising these features through wireframes and then high
      composition mockups. ### Ideas and iterations I produced wireframes based
      on early brainstorming sessions and business requirements. These
      wireframes enabled the business to visualise how features would look and
      aided in decision making. ### Mockups Selected wireframes were explored
      further with full composition mockups. It was at this point where we
      started exploring the visual style of the app. The business wanted to
      incorporate elements of the Hospedia brand into the app as it is heavily
      tied to the bedside terminals. ### Prototyping I produced prototypes for
      key screens and user stories that needed visualising further. These helped
      us ensure things like the information architecture were correct. ###
      Specifications & guidelines As we didn’t have the resources in house to
      build mobile apps the development of the app was done by a third party. I
      was responsible for liaising with them, ensuring they had up to date
      designs and assets.
    </CasestudyTemplate>
  );
}
